import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

export type TSupport = {
  alias?: string[];
  id?: number;
  name?: string;
  taxonomy_id?: string;
};

export const getSupports = async (): Promise<TSupport[]> => {
  return mediaManagerClient.get('/api/v1/supports').then(({ data }) => data);
};
type QueryFnType = typeof getSupports;

type UseProgramsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetSupports = ({ config }: UseProgramsOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['supports'],
    queryFn: getSupports,
  });
};
